import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

export async function trackAlternativeExperienceLinkClicked(
    clickText: string,
    clickUrl: string,
): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.ChooseAlternativeExperienceForExistingVoucher,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
}
